import { render, staticRenderFns } from "./UserItems.vue?vue&type=template&id=1f53bd5f&scoped=true"
import script from "./UserItems.vue?vue&type=script&lang=js"
export * from "./UserItems.vue?vue&type=script&lang=js"
import style0 from "./UserItems.vue?vue&type=style&index=0&id=1f53bd5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53bd5f",
  null
  
)

export default component.exports